export enum ProjectStatus {
  ACTIVE = 'active',
  FINISHED = 'finished'
}
